// extracted by mini-css-extract-plugin
export default {"uploadedMessage":"AttachYangFiles_uploadedMessage__qS5KE"};